import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RecommendationService } from '../../recommendation/recommendation.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import { ResidentialService } from '../../residential.service';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';
@Component({
  selector: 'app-ssn-openwithdeposit',
  templateUrl: './ssn-openwithdeposit.component.html',
  styleUrls: ['./ssn-check.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class SSnopenwithdepositComponent implements OnInit {
  selectedProduct;
  ssnFailedEnergyProvidersList;
  providerContact;
  ssndepostList;
  isChecked = false;
  elem4;
  elem5;
  elem6;
  deviceWidth;
  ansinSSncheck;
  ansinSSncheck1;
  timer;
  time = 2000;
  timeTrue = false;
  hideHome = false;
  vishome;
  accountNumber;
  productName;
  constructor(
    private router: Router,
    private recommendationService: RecommendationService,
    private residentialService: ResidentialService,
    private _scrollToService: ScrollToService
  ) {
    // console.log.log(this.recommendationService.signupProduct);
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    if (!_.isEmpty(this.recommendationService.ssnFailedEnergyProviders)) {
      this.ssnFailedEnergyProvidersList =
        this.recommendationService.ssnFailedEnergyProviders;
      sessionStorage.setItem(
        'ssnFailedEnergyProviders',
        JSON.stringify(this.ssnFailedEnergyProvidersList)
      );
    } else {
      this.ssnFailedEnergyProvidersList = JSON.parse(
        sessionStorage.getItem('ssnFailedEnergyProviders')
      );
    }
    // console.log.log(this.selectedProduct);
    this.ssndepostList = {
      value4: false,
      value5: false,
      value6: false,
    };
    this.hideHome = true;
    var vishome = this.hideHome;
    sessionStorage.setItem('hideHome', JSON.stringify(vishome));
    this.deviceWidth = window.innerWidth;

    var postresult = JSON.parse(sessionStorage.getItem('postresult'));
    if (postresult != undefined) {
      this.accountNumber = postresult['data']
        ? postresult['data'].accountNumber
        : '';
      this.productName = postresult['data']
        ? postresult['data'].rateOfferings['ratePlanName']
        : '';
    }
  }

  onChangeRole(event) {
    this.isChecked = event.target.checked;

    if (this.deviceWidth < 768) {
      this.elem4 = document.getElementById('callnowtopostDeposit');
      this.elem5 = document.getElementById('notInterested');
      this.elem6 = document.getElementById('thankyou');
    } else {
      this.elem4 = document.getElementById('callnowtopostDeposit');
      this.elem5 = document.getElementById('notInterested');
      this.elem6 = document.getElementById('thankyou');
    }
    if (this.isChecked === true) {
      if (event.target.value === 'Call now to post deposit') {
        this.ssndepostList = {
          value4: true,
          value5: false,
          value6: false,
        };
        this.ansinSSncheck = '1-855-780-5209';
        this.elem4.parentElement.classList.add('active-select');
        if (_.contains(this.elem5.parentElement.classList, 'active-select')) {
          this.elem5.parentElement.classList.remove('active-select');
        }

        this.timer = setTimeout(() => {
          this.timeTrue = true;
          if (this.deviceWidth < 768) {
            this.triggerScrollTo('addf_id');
          }
        }, this.time);
      } else if (event.target.value === 'Not interested') {
        this.ssndepostList = {
          value4: false,
          value5: true,
          value6: false,
        };
        this.ansinSSncheck = 'Goodbye';
        this.ansinSSncheck1 = 'ccc';
        this.timeTrue = false;
        this.elem5.parentElement.classList.add('active-select');
        if (_.contains(this.elem4.parentElement.classList, 'active-select')) {
          this.elem4.parentElement.classList.remove('active-select');
        }
        if (this.deviceWidth < 768) {
          this.triggerScrollTo('addf_id');
        }
        this.timer = setTimeout(() => {
          this.gotoHome();
        }, this.time);
      } else if (event.target.value === 'Thank you') {
        this.ssndepostList = {
          value4: true,
          value5: false,
          value6: true,
        };
        this.ansinSSncheck1 = 'Goodbye';

        this.elem6.parentElement.classList.add('active-select');
        if (_.contains(this.elem5.parentElement.classList, 'active-select')) {
          this.elem5.parentElement.classList.remove('active-select');
        }
        if (this.deviceWidth < 768) {
          this.triggerScrollTo('secondAns_id');
        }
        this.timer = setTimeout(() => {
          this.gotoHome();
        }, this.time);
      }
    } else {
      this.ssndepostList = {
        value4: false,
        value5: false,
        value6: false,
      };
      this.ansinSSncheck1 = 'ccc';
      this.timeTrue = false;
      this.elem4.parentElement.classList.remove('active-select');
      this.elem5.parentElement.classList.remove('active-select');
    }
  }

  public triggerScrollTo(destination) {
    const config: ScrollToConfigOptions = {
      target: destination,
      duration: 50,
      easing: 'easeOutElastic',
    };
    this._scrollToService.scrollTo(config);
  }

  ngOnInit() {}

  gotoHome() {
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      const hg_accountId = window.location.href.split('/').pop();
      sessionStorage.removeItem('APIESIIDValues');
      sessionStorage.removeItem('esiidValue');
      sessionStorage.removeItem('recommendedProducts');
      sessionStorage.removeItem('userResponse');
      this.router.navigate(['user-settings', hg_accountId]);
    } else {
      this.router.navigate(['/']);
    }
  }
  shop(selectedOption) {
    if (selectedOption === 'prepaid') {
      this.recommendationService.ssnFailedText = selectedOption;
      sessionStorage.setItem(
        'ssnFailedText',
        this.recommendationService.ssnFailedText
      );
      if (!_.isEmpty(this.ssnFailedEnergyProvidersList)) {
        this.recommendationService.ssnFailedEnergyProviders = [];
        sessionStorage.setItem(
          'ssnFailedEnergyProviders',
          JSON.stringify(this.recommendationService.ssnFailedEnergyProviders)
        );
      }
    } else {
      this.recommendationService.ssnFailedText = selectedOption;
      if (!_.isEmpty(this.ssnFailedEnergyProvidersList)) {
        this.recommendationService.ssnFailedEnergyProviders =
          this.ssnFailedEnergyProvidersList;
      }
      this.recommendationService.ssnFailedEnergyProviders.push(
        this.selectedProduct.energy_provider
      );
      sessionStorage.setItem(
        'ssnFailedText',
        this.recommendationService.ssnFailedText
      );
      sessionStorage.setItem(
        'ssnFailedEnergyProviders',
        JSON.stringify(this.recommendationService.ssnFailedEnergyProviders)
      );
    }
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }
}
